import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'update-dimensions.title',
    // eslint-disable-next-line max-len
    defaultMessage: 'Add/Remove Assessment Dimensions or Survey Competencies/Abilities for an account in your Organisation',
  },
  status: {
    id: 'update-dimensions.treeTable.status',
    defaultMessage: 'Status',
  },
  distortions: {
    id: 'update-dimensions.distortions',
    defaultMessage: 'Distortions',
  },
  dimensions: {
    id: 'update-dimensions.dimensions',
    defaultMessage: 'Dimensions',
  },
  noOperation: {
    id: 'update-dimensions.treeTable.noOperation',
    defaultMessage: 'No operation available for this account.',
  },
  dimensionsActivated: {
    id: 'update-dimensions.treeTable.dimensionsActivated',
    defaultMessage: 'Dimensions activated',
  },
  dimensionsActivatedForSection: {
    id: 'update-dimensions.treeTable.dimensionsActivatedForSection',
    defaultMessage: 'Dimensions activated for this section',
  },
  distortionsActivated: {
    id: 'update-dimensions.treeTable.distortionsActivated',
    defaultMessage: 'Distortions activated',
  },
  abilitiesActivated: {
    id: 'update-dimensions.treeTable.abilitiesActivated',
    defaultMessage: 'Abilities activated',
  },
  abilitiesActivatedForCompetence: {
    id: 'update-dimensions.treeTable.abilitiesActivatedForCompetence',
    defaultMessage: 'Abilities activated for this competence',
  },
  add: {
    id: 'update-dimensions.btnLbl.add',
    defaultMessage: 'Add',
  },
  remove: {
    id: 'update-dimensions.btnLbl.remove',
    defaultMessage: 'Remove',
  },
  addInterests: {
    id: 'update-dimensions.btnLbl.addInterests',
    defaultMessage: 'Add all',
  },
  removeInterests: {
    id: 'update-dimensions.btnLbl.removeInterests',
    defaultMessage: 'Remove all',
  },
  filterAccount: {
    id: 'update-dimensions.filterAccount',
    defaultMessage: 'Filter account ...',
  },
  addAbilitySuccess: {
    id: 'update-dimensions.addAbilitySuccess',
    defaultMessage: 'Ability has been added',
  },
  addAbilityError: {
    id: 'update-dimensions.addAbilityError',
    defaultMessage: 'There was an error adding this ability.',
  },
  removeAbilitySuccess: {
    id: 'update-dimensions.removeAbilitySuccess',
    defaultMessage: 'Ability has been removed.',
  },
  removeAbilityError: {
    id: 'update-dimensions.removeAbilityError',
    defaultMessage: 'There was an error removing this ability.',
  },
  addDimensionSuccess: {
    id: 'update-dimensions.addDimensionSuccess',
    defaultMessage: 'Dimension has been added.',
  },
  addDimensionError: {
    id: 'update-dimensions.addDimensionError',
    defaultMessage: 'There was an error adding this dimension.',
  },
  removeDimensionSuccess: {
    id: 'update-dimensions.removeDimensionSuccess',
    defaultMessage: 'Dimension has been removed.',
  },
  removeDimensionError: {
    id: 'update-dimensions.removeDimensionError',
    defaultMessage: 'There was an error removing this dimension.',
  },
  addDistortionSuccess: {
    id: 'update-dimensions.addDistortionSuccess',
    defaultMessage: 'Distortion has been added.',
  },
  addDistortionError: {
    id: 'update-dimensions.addDistortionError',
    defaultMessage: 'There was an error adding this distortion.',
  },
  removeDistotionSuccess: {
    id: 'update-dimensions.removeDistortionSuccess',
    defaultMessage: 'Distortion has been removed.',
  },
  removeDistorionError: {
    id: 'update-dimensions.removeDistortionError',
    defaultMessage: 'There was an error removing this distortion.',
  },
  addInterestsSuccess: {
    id: 'update-dimensions.addInterestsSuccess',
    defaultMessage: 'Interests dimensions added.',
  },
  addInterestsError: {
    id: 'update-dimensions.addInterestsError',
    defaultMessage: 'There was a problem adding interests dimensions.',
  },
  removeInterestsSuccess: {
    id: 'update-dimensions.removeInterestsSuccess',
    defaultMessage: 'Interests dimensions have been removed.',
  },
  removeInterestsError: {
    id: 'update-dimensions.removeInterestsError',
    defaultMessage: 'There was a problem removing interests dimensions.',
  },
});

export default messages;
